import React from 'react';
import LoginPage from './LoginPage';
import { CommunityProvier } from 'features/community/presentation/provider/community.provider';
import { CommunityForm } from 'common/presentation/components';

const StoreLogin = () => (
	<main>
		<CommunityProvier>
			<LoginPage />
			<CommunityForm />
		</CommunityProvier>
	</main>
);

export default StoreLogin;
